import React, { useEffect, useState } from "react";
import { Button, Container, Grid } from "@material-ui/core";
import { useSnackbar } from "notistack";
import AddIcon from "@material-ui/icons/Add";

import AddProjectForm from "./AddProjectForm";
import auth from "../../auth/authService";
import Breadcum from "../common/breadcum";
import {
  deleteProject,
  getProjectsByYear,
} from "../../services/projectService";
import Loading from "../common/loading";
import { notifications } from "../../utils/messages";
import ProjectsTable from "./projectsTable";
import ProjectYear from "./projectYear";
import { ROLES } from "../../utils/constants";
import { useModal } from "../../hooks/useModal";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import { getPrograms } from "../../services/programService";
import { getLines } from "../../services/lineService";

const currentYear = new Date().getFullYear().toString();

const Projects = ({ history }) => {
  const [year, setYear] = useState(currentYear);
  const [projects, setProjects] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [lines, setLines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [open, handleOpen, handleClose] = useModal();

  const populateProjects = async (year) => {
    setIsLoading(true);
    const { data: projects } = await getProjectsByYear(year);
    setProjects(projects);
    //setResolucion(resolucion);
    setIsLoading(false);
  };

  const populateLines = async () => {
    const { data: lines } = await getLines();
    setLines(lines);
  };

  const populatePrograms = async () => {
    const { data: programs } = await getPrograms();
    setPrograms(programs);
  };

  useEffect(() => {
    populateProjects(year);
    populateLines();
    populatePrograms();
  }, [year]);

  const handleDelete = async (projectSlug) => {
    const originalProjects = [...projects];
    const newProjects = originalProjects.filter(
      (project) => project.slug !== projectSlug
    );
    setProjects(newProjects);
    try {
      await deleteProject(projectSlug);
      enqueueSnackbar(notifications.DELETE_SUCCESS, {
        variant: "success",
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        this.props.enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      } else if (ex.response.status === 403) {
        this.props.enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      }
      setProjects(originalProjects);
    }
  };

  const handleChangeSelected = (event, values, nameSelect) => {
    setYear(values);
  };

  return (
    <Container maxWidth="xl">
      <Loading open={isLoading} />
      <Breadcum lastLabel={"Proyectos"} />
      <Grid item xs={12} sm={6} md={4} lg={3} style={{ marginBottom: "1em" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          startIcon={<AddIcon />}
        >
          Nuevo proyecto
        </Button>
        <ProjectYear
          selectedYear={year}
          onChangeSelect={handleChangeSelected}
        />
      </Grid>
      <AddProjectForm
        open={open}
        onClose={handleClose}
        history={history}
        selectedYear={year}
      />
      <ProjectsTable
        datas={projects}
        onDelete={handleDelete}
        history={history}
      />
      <br /> <br />
      <Grid container justify="center" style={{ marginBottom: "1em" }}>
        {projects.length > 0 &&
          auth.getSelectedRole().name !== ROLES.INVESTIGADOR && (
            <div className="d-flex flex-row mb-3">
              {" "}
              <br /> <br />
              <Paper className="paper" elevation={100}>
                <h1> REPORTES </h1>
                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Estado/`,
                    state: { data: projects },
                  }}
                >
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Proyectos por Estado
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Cobertura/`,
                    state: { data: projects },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Proyectos por Cobertura
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Multidisciplinario/`,
                    state: { data: projects },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Proyectos Multidisciplinarios
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Genero/`,
                    state: { data: projects },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Género de Investigadores
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Estudiantes/`,
                    state: { data: projects },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Clasificación de Estudiantes por Proyecto
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Programas`,
                    state: { projects: projects, programs: programs },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Programas utilizados
                  </Button>
                </Link>

                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: `/proyectos/${year}/reporte/Lineas`,
                    state: { projects: projects, lines: lines },
                  }}
                >
                  <br /> <br />
                  <Button color="primary" style={{ marginTop: ".2em" }}>
                    Reporte de Líneas utilizadas
                  </Button>
                </Link>
              </Paper>
            </div>
          )}
      </Grid>
    </Container>
  );
};

export default Projects;

//variant="outlined"
